import {
  ComponentProperties,
  HasComponents,
  HasKey,
  HasSteps,
  StandardSpecificData,
  StandardSpecificDefinition,
  StandardSpecificStepDataItem,
} from "../../route/shared/projects/project/overview/components/StandardSpecificSection/types";

// Returns false when a project has no standard-specific data (e.g. No standard projects, where
// standardSpecificData is an empty object "{}"). Used to hide all standard-specific panels.
export const hasStandardSpecificData = (data: unknown): boolean => {
  if (data === null || data === undefined) return false;
  if (typeof data === "string") {
    const trimmed = data.trim();
    return trimmed !== "" && trimmed !== "{}";
  }
  if (typeof data === "object") return Object.keys(data).length > 0;
  return false;
};

// Returns true when the schema defines something displayable (at least one step). Used to decide
// whether to show the standard-specific panel: as long as the definition is non-empty we render it,
// so users can enter data even before any standard-specific data exists on the project.
export const hasStandardSpecificDefinition = (definition: StandardSpecificDefinition | undefined): boolean => {
  return !!definition?.steps?.length;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getValueByDataPath = (data: StandardSpecificData, dataPath: string): any => {
  const keys = dataPath.split(".");
  let value: StandardSpecificData | StandardSpecificStepDataItem | undefined = data;
  keys.forEach((key: string) => {
    if (value !== undefined) {
      if (value.steps) {
        value = value.steps.find((step: HasKey) => step.key === key);
      } else if (value.data) {
        value = value.data[key];
      }
    }
  });
  return value;
};

export const getComponentPropertiesByDataPath = (
  data: StandardSpecificDefinition,
  dataPath: string
): ComponentProperties | undefined => {
  const keys = dataPath.split(".");
  let value: StandardSpecificDefinition | (HasSteps & HasComponents) | undefined = data;
  let res;

  keys.forEach((key: string) => {
    if (value !== undefined) {
      if (value.steps) {
        value = value.steps.find((step: HasKey) => step.key === key);
      } else if (value.components) {
        res = value.components.find((component: HasKey) => component.key === key)?.componentProperties;
      }
    }
  });
  return res;
};
